// Static content shared across pages. Extend as needed via admin panel later.

export const CLINIC = {
  name: "Physio Hyve Clinic",
  logo: "/logo-icon.png",
  logoFull: "/logo-full.png",
  phone: "+91 85120 85860",
  phoneRaw: "+918512085860",
  whatsapp: "918512085860",
  address:
    "Plot No. 115-A, Basement, Nangloi–Najafgarh Road, Ahir Mohalla, Nangloi Jat, Delhi – 110041",
  mapQuery: "Physio+Hyve+Clinic+Nangloi+Delhi",
  email: "care@physiohyve.com",
  rating: 4.8,
  reviewsCount: 157,
};

export const CONDITION_CARDS = [
  { slug: "back-pain", title: "Back Pain", short: "Persistent, radiating or postural." },
  { slug: "neck-pain", title: "Neck Pain", short: "Stiffness, headaches, desk strain." },
  { slug: "knee-pain", title: "Knee Pain", short: "Injuries, arthritis, post-surgery." },
  { slug: "shoulder-pain", title: "Shoulder Pain", short: "Frozen shoulder, rotator cuff." },
  { slug: "sports-injury", title: "Sports Injury", short: "Return-to-sport rehabilitation." },
  { slug: "acl", title: "ACL / Ligament Injury", short: "Pre & post-op rehabilitation." },
  { slug: "post-surgery", title: "Post-Surgery Recovery", short: "Structured, graded recovery." },
  { slug: "neuro", title: "Stroke & Neuro Rehab", short: "Movement, balance, function." },
  { slug: "balance", title: "Balance & Walking", short: "Gait, falls, coordination." },
  { slug: "other", title: "Other Pain or Movement", short: "Not sure? We'll help you decide." },
];

export const SERVICES = [
  { slug: "general", title: "General Physiotherapy", tag: "core", blurb: "Personalised assessment, hands-on care and structured exercise programmes." },
  { slug: "sports-rehab", title: "Sports Injury Rehabilitation", tag: "sports", blurb: "Return to your sport with confidence — strength, control and performance." },
  { slug: "acl-rehab", title: "ACL Rehabilitation", tag: "sports", blurb: "Comprehensive pre- and post-operative ACL rehabilitation programmes." },
  { slug: "pcl-rehab", title: "PCL Rehabilitation", tag: "sports", blurb: "Structured PCL rehabilitation with staged return-to-activity milestones." },
  { slug: "post-surgical", title: "Post-Surgical Rehabilitation", tag: "surgery", blurb: "Recovery pathways after orthopaedic and joint replacement surgery." },
  { slug: "neuro-rehab", title: "Neurological Rehabilitation", tag: "neuro", blurb: "Movement, balance and functional retraining after neurological conditions." },
  { slug: "stroke-rehab", title: "Stroke Rehabilitation", tag: "neuro", blurb: "Task-specific, intensive rehab focused on independence and quality of life." },
  { slug: "back-pain", title: "Back Pain Physiotherapy", tag: "spine", blurb: "Evidence-informed care for acute, chronic and radicular back pain." },
  { slug: "neck-pain", title: "Neck Pain Physiotherapy", tag: "spine", blurb: "Manual therapy and movement retraining for cervical pain and headaches." },
  { slug: "knee-rehab", title: "Knee Rehabilitation", tag: "joint", blurb: "From patellofemoral pain to complex reconstructions." },
  { slug: "shoulder-rehab", title: "Shoulder Rehabilitation", tag: "joint", blurb: "Frozen shoulder, rotator cuff and post-surgical shoulder rehab." },
  { slug: "gait-training", title: "Balance & Gait Training", tag: "neuro", blurb: "Restore confident, coordinated walking after injury or illness." },
  { slug: "chiropractic", title: "Chiropractic Care", tag: "manual", blurb: "Where clinically appropriate, integrated within a broader assessment." },
  { slug: "dry-needling", title: "Dry Needling", tag: "manual", blurb: "Trigger-point release to complement active rehabilitation." },
  { slug: "cupping", title: "Cupping Therapy", tag: "manual", blurb: "Soft-tissue therapy where indicated as part of a plan." },
  { slug: "taping", title: "Kinesiology Taping", tag: "manual", blurb: "Support, feedback and offload during rehabilitation." },
  { slug: "mulligan", title: "Mulligan Techniques", tag: "manual", blurb: "Mobilisation-with-movement for joint stiffness and pain." },
  { slug: "manual-therapy", title: "Manual Therapy", tag: "manual", blurb: "Hands-on assessment and treatment integrated with exercise." },
  { slug: "strength", title: "Strength & Conditioning", tag: "performance", blurb: "Rehabilitation-informed strength for durability and performance." },
  { slug: "return-to-sport", title: "Return-to-Sport Rehab", tag: "sports", blurb: "Objective testing and progressive loading to safe sport re-entry." },
];

export const TEAM = [
  {
    slug: "amit-sharma",
    name: "Dr. Amit Sharma",
    title: "Clinic Head · Head Physiotherapist",
    photo: "/team/amit-sharma.jpg",
    focus: [
      "Sports Rehabilitation",
      "ACL Rehabilitation",
      "Post-Surgical Recovery",
      "Return-to-Sport Testing",
    ],
    bio:
      "Head of Physio Hyve Clinic with 17+ years of clinical experience. Holds a Fellowship in Sports Rehabilitation (Level II). Leads the clinic's rehabilitation programmes, mentors the team and regularly writes on the Physio Hyve journal.",
    href: "/team/amit-sharma",
  },
  {
    slug: "manishika-patait",
    name: "Dr. Manishika Patait",
    title: "Maternal Care Lead · Childbirth & Lactation Educator",
    photo: "/team/manishika-patait.jpg",
    focus: [
      "Prenatal & Postnatal Exercise",
      "Childbirth Education",
      "Lactation Support",
      "Prenatal & Postnatal Yoga",
    ],
    bio:
      "BPT, DNYS · CAPPA (US)-certified childbirth and lactation educator with 13+ years of experience in women's physiotherapy, prenatal & postnatal fitness and maternal wellness.",
    href: "/maternal-care",
  },
  {
    slug: "senior-physiotherapist",
    name: "Senior Physiotherapist",
    title: "Rehabilitation Specialist",
    photo:
      "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.0.3&q=85&w=600",
    focus: ["Sports Injuries", "Manual Therapy", "Return-to-Sport"],
    bio:
      "Placeholder profile awaiting admin verification. Update via the admin dashboard once clinician details are confirmed.",
  },
  {
    slug: "neuro-lead",
    name: "Neurological Rehab Lead",
    title: "Neuro Physiotherapist",
    photo:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.0.3&q=85&w=600",
    focus: ["Stroke Rehab", "Balance & Gait", "Home Programmes"],
    bio:
      "Placeholder profile awaiting admin verification. Focused on stroke rehabilitation, gait retraining and family-centred programmes.",
  },
];

export const RECOVERY_PATH = [
  { step: 1, title: "Assess", body: "We understand your symptoms, movement, strength, function and goals." },
  { step: 2, title: "Identify", body: "We identify contributing factors and functional limitations." },
  { step: 3, title: "Personalise", body: "We build a rehabilitation strategy that fits your life." },
  { step: 4, title: "Treat & Train", body: "Hands-on techniques, exercise and movement retraining come together." },
  { step: 5, title: "Progress", body: "We track improvement and gradually raise the challenge." },
  { step: 6, title: "Return", body: "You return to what matters — daily life, work, independence, or sport." },
];

export const FAQS = [
  { q: "Do I need a doctor's referral to visit Physio Hyve?", a: "No referral is required. You can book an assessment directly. If you have reports or a referral letter, please bring them along." },
  { q: "How many sessions of physiotherapy will I need?", a: "This depends on your condition, assessment findings, goals and how you respond to rehabilitation. We'll discuss a realistic plan after your first visit." },
  { q: "How much does physiotherapy cost?", a: "Session costs vary depending on the type and duration of treatment. Please call or WhatsApp us for current fees — we're transparent about pricing." },
  { q: "Is physiotherapy painful?", a: "Some techniques may cause temporary discomfort, but treatment should not be traumatic. Your therapist adapts to your tolerance." },
  { q: "Can physiotherapy help me avoid surgery?", a: "In many cases, structured rehabilitation is an appropriate first line of care. We'll be honest if we believe surgical review is warranted." },
  { q: "Do you provide ACL rehabilitation?", a: "Yes. We provide comprehensive pre-operative and post-operative ACL rehabilitation, including return-to-sport testing." },
  { q: "Do you provide neurological rehabilitation?", a: "Yes. We offer stroke rehabilitation, gait retraining, balance work and functional retraining within our scope of practice." },
  { q: "Can I share my MRI report on WhatsApp?", a: "Yes. You can share reports securely via WhatsApp. We handle patient information respectfully." },
  { q: "Where is Physio Hyve located?", a: "Plot No. 115-A, Basement, Nangloi–Najafgarh Road, Ahir Mohalla, Nangloi Jat, Delhi – 110041." },
];
